import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import Loader from "../../atomic/Loader/Loader";
import Panel from "../../atomic/Panel/Panel";
import InputEdit, {
  FileUploadEdit,
  TextEdit
} from "../../atomic/InputEdit/InputEdit";
import Button from "../../atomic/Button/Button";
import { Link } from "react-router-dom";
import { Route, Switch, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  loadLocationsAction,
  saveLocationAction,
  addLocationAction,
  getLocations,
  isLoading,
  isSaving
} from "../../../state/data";
import MapDiv from "../MapDiv/MapDiv";
import Geocoding from "../MapDiv/Geocoding";

const Header = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  background-color: rgb(234, 234, 234);
  width: 100%;
  border-bottom: 1px solid rgb(196, 196, 196);
  justify-content: space-between;
  padding: 20px;
  margin-bottom: 20px;
  height: 50px;
  svg {
    margin-right: 10px;
  }
`;

const Root = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export default withTheme(({ theme }) => {
  let { locationId } = useParams();
  const locations = useSelector(getLocations);
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const saving = useSelector(isSaving);
  const id = locationId;
  const [added, setAdded] = useState(false);
  useEffect(() => {
    if (!locations) {
      dispatch(loadLocationsAction());
    }
  }, []);
  useEffect(() => {
    if (!locations) {
      return;
    }
    if (!added && !saving && !locations.filter(l => l.id === id)[0]) {
      setAdded(true);
      dispatch(addLocationAction({ id }));
    }
  }, [locations, saving, added]);
  if (!locations || loading) {
    return <Loader />;
  }
  const location = locations.filter(l => l.id === id)[0];
  if (!location) {
    return <Loader />;
  }
  const save = (loc, field) => dispatch(saveLocationAction(loc, field));
  return (
    <Root>
      <Header>
        <div>
          <Link to="/company">
            {" "}
            <Button>
              <FontAwesomeIcon
                icon={["fas", "arrow-left"]}
                size="1x"
                color={theme.color1}
              />{" "}
              Back to Locations
            </Button>
          </Link>
        </div>
        <div></div>
      </Header>
      <Panel>
        <InputEdit
          onChange={v => save({ ...location, address: v }, "address")}
          saving={saving}
          required
          value={location.address}
          field="address"
          label={"Address"}
          canEdit={true}
          validate={v => {
            if (!v || !v.trim()) {
              return "Address is required";
            }
            return "";
          }}
          placeholder="Enter Address"
        />
        <MapDiv onFullSelect={() => {}} />
        {location.coords && (
          <Geocoding markers={[location.coords]} center={location.coords} />
        )}
      </Panel>
    </Root>
  );
});
